import type {Context} from '../types';

export default function (context: Context) {
  const {jsonNode} = context.node;

  const isLocalesEmptyNode = jsonNode.type === 'LocalesEmpty';

  const hasUnnecessaryData =
    jsonNode.data?.tag != null || jsonNode.data?.text != null;

  return {
    needed: isLocalesEmptyNode && hasUnnecessaryData,
    logData: {
      msg: 'LocalesEmpty node migration',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      if (jsonNode.data?.tag != null) {
        // eslint-disable-next-line webflow/no-delete
        delete jsonNode.data.tag;
      }
      if (jsonNode.data?.text != null) {
        // eslint-disable-next-line webflow/no-delete
        delete jsonNode.data.text;
      }
    },
  };
}
